import { TextMessage } from './TextMessage'
import { ChatMessage } from 'types/chat-message'
import { messagesSelectors } from 'store/messages'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { getUserDisplayName } from 'utils/user'
import { AttachmentMessage, fromUpload } from 'components/messages/AttachmentMessage'

export type OperatorMessageProps = {
  messageItem: ChatMessage
  index: number
}

export const OperatorMessage = ({ messageItem }: OperatorMessageProps) => {
  const { t } = useTranslation()
  const currentChatParticipants = useSelector(messagesSelectors.currentChatParticipants)

  const operator = useMemo(() => {
    return _.find(currentChatParticipants, (participant) => participant.userId === messageItem.senderId)
  }, [currentChatParticipants, messageItem])

  return (
    <div className={'flex flex-col gap-0.5'}>
      <TextMessage
        senderName={getUserDisplayName(operator?.user) || t('operator')}
        text={messageItem.message}
        messageItem={messageItem}
      />
      {messageItem.operatorAttachments?.map((att) => (
        <AttachmentMessage attachment={fromUpload(att)} key={att._id} />
      ))}
    </div>
  )
}
